<template>
    <vx-popover hover arrow placement="top">
        <vx-badge :color="style.color" size="xs">
            <span class="flex items-center gap-1">
                {{ style.label }}
                <font-awesome-icon
                    fixedWidth
                    :icon="style.icon"
                    :class="['text-xs', style.iconClass]"
                ></font-awesome-icon>
            </span>
        </vx-badge>
        <template v-slot:content>
            <div class="text-center p-1">
                <div class="text-xs text-slate-500">Subscription Status</div>
                <div class="text-sm text-slate-800">
                    <span class="capitalize">{{ props.type }}: </span>
                    <span>{{ style.label }}</span>
                </div>
            </div>
        </template>
    </vx-popover>
</template>

<script setup>
import { faArrowRightToBracket, faArrowRightFromBracket, faSquareDashed } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBadge, VxPopover } from '@voxie/frontend-components';
import { computed } from 'vue';

const props = defineProps({
    type: {
        type: String,
        required: true,
    },
    status: String,
});

const style = computed(() => {
    if (props.status === 'opt_in') {
        return {
            color: 'primary',
            label: 'Opt-in',
            icon: faArrowRightToBracket,
            iconClass: 'text-sky-500',
        };
    }
    if (props.status === 'opt_out') {
        return {
            color: 'amber',
            label: 'Opt-out',
            icon: faArrowRightFromBracket,
            iconClass: 'text-amber-500',
        };
    }

    return {
        color: 'slate',
        label: 'No-pref',
        icon: faSquareDashed,
        iconClass: 'text-slate-500',
    };
});
</script>
